import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'dateISOString' })
export class DateISOStringPipe implements PipeTransform {

    public transform(value: any, args?: any): any {
        let date = value;
        const datePipe = new DatePipe('en-US');

        try {
            // tslint:disable-next-line:max-line-length
            date = new Date(`${date.substr(0, 4)}/${date.substr(5, 2)}/${date.substr(8, 2)} ${date.substr(11, 2)}:${date.substr(14, 2)}:${date.substr(17, 2)}`);
            date = datePipe.transform(date, args);
        } catch (e) {
            date = '';
        }

        return date;
    }

}
